import React from 'react';
import './QuotationResponseTableHeader.css';

function QuotationResponseTableHeader(props) {
    const {coverage, premium, selected} = props;
    return (
        <div className="ctheader__container">
            <div className="ctheader__text__container">
                <p className={selected ? "ctheader__text ctheader__text__selected" : "ctheader__text"}>{coverage}</p>
            </div>
            <p  className={selected ? "ctheader__text--highlighted ctheader__text__selected" : "ctheader__text--highlighted"}>${premium}</p>
        </div>
    );
}

export default QuotationResponseTableHeader;